// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader-styles_header__1GwcO","heading":"ModalHeader-styles_heading__2ccmC"};